import { createElement, forwardRef } from 'react';
import hoistNonReactStatics from 'hoist-non-react-statics';
import invariant from 'invariant';

import useCart from 'Hooks/useCart';

export default function withCart(Component) {
  const displayName = `withCart(${ (Component.displayName || Component.name || 'Component') })`;

  const WithCart = forwardRef((props, ref) => {
    const cartContext = useCart();
    invariant(cartContext, `You should not use <${displayName} /> outside a <CartProvider>`);
    return createElement(Component, {
      cart: cartContext,
      ref,
      ...props
    });
  });

  WithCart.displayName = displayName;
  WithCart.WrappedComponent = Component;

  return hoistNonReactStatics(WithCart, Component);
}
